module.exports = __webpack_public_path__ + "ef35ad7792a67457f2ad99345eb49dee.svg";